/* eslint-disable */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

// Reads from the local Apollo Client
const AUTH_QUERY = gql`
    query AuthQuery {
        isLoggedIn @client
    }
`;

export const PrivateRoute = ({ children }) => {
    const { data: authState } = useQuery(AUTH_QUERY);
    const location = useLocation();

    return authState.isLoggedIn ? (
        children
    ) : (
        <Navigate to="/developer/login" state={{ from: location }} replace />
    );
};
